var api = {};
var apiurl;

var apiurl = window.location.origin+"/"; //"http://www.voltadolago.com.br/";

if(window.location.pathname == "/indexdev.html"){
    var apiurl = "http://voltadolagocaixa.test/";
}
// var apiurl = "http://localhost:8888/";

// apiurl = "http://www.voltadolago.com.br/";


api = {
    apiurl: apiurl,
    percurso: 'https://api-legado.voltadolagocaixa.com.br/index.php/tools/required/percurso.php',
    mapaincorporados: apiurl + 'mapaspaineis/mapa1.php',
    server: apiurl,//'http://189.6.18.55:5000/',
    undercover: 'http://voltadolago.com.br:5657',
    tracker: 'http://khartes.com.br:3000/api/',
    // tracker: 'http://192.168.0.10:3000/api/',
}

if(window.location.origin.includes('localhost')){
    api.percurso = '/api/index.php/tools/required/percurso.php';
}



window.API = api;

export default api;